import React from "react";
import { FormLabel } from "react-bootstrap";
import { labels } from "../../../../localization/labels";

const Home = props => (
  <>
    <div className="container">
      <FormLabel className="Title">{labels.welcome}</FormLabel>
    </div>
  </>
);

export default Home;
